import { TokenService } from "../services/storage.service";
import ZetReportService from "../services/zet-report.service";

const state = {
	currentReport: {},
	currentZReport: {},
	currentXReport: {},
	zReportById: {},
	currentSession: [],
	zetReport: [],
	xReport: [],
	chechboxId:null,
	zetReportMonthly: [],
	zReportError: {
		boolean: false,
		message: ""
	},
	zetReportError: {
		boolean: false,
		message: ""
	},
	closeZreportError: {
		boolean: false,
		message: ""
	}
};

const getters = {
	getCurrentSession: state => {
		return state.currentSession;
	},
	getZetReport: state => {
		return state.zetReport;
	},
	getReportX: state => {
		return state.xReport;
	},
	getReportMonthly: state => {
		return state.zetReportMonthly;
	}
};
const actions = {
	async getCurrentZReport({ commit }, depId) {
		try {
			const response = await ZetReportService.getCurrentZReport(depId, localStorage.getItem('cash_id'));
			commit("setCurrentZReport", response.data);
		} catch (e) {
			//let response = JSON.parse(e.request.response);
			//commit('fetchGoodError', {message: response.message, boolean: true});
			throw e;
		}
	},
	async getCurrentXReport({ state, commit }, depId) {
		try {
			const response = await ZetReportService.getCurrentXReport(depId, localStorage.getItem('cash_id'));
			commit("setCurrentXReport", response.data);
		} catch (e) {
			//let response = JSON.parse(e.request.response);
			//commit('fetchGoodError', {message: response.message, boolean: true});
			commit("setCurrentXReport", e);
			throw e;
		}
	},
	async getZReportById({ commit }, zReportIdAndDepId,) {
		try {
			const response = await ZetReportService.getZReportById(
					zReportIdAndDepId
			);
			commit("setZReportById", response.data);
			commit("setZReportError", { message: "", boolean: false });
		} catch (e) {
			// let response = JSON.parse(e.request.response);
			// commit("setZReportError", {
			// 	message: response.message,
			// 	boolean: true
			// });
			throw e;
		}
	},
	async getZReport({ commit }, payload) {
		try {
			let response = await ZetReportService.getZReportByDepartmentId(
				payload, localStorage.getItem('cash_id')
			);
			await commit("setZetReport", response.data);
			await commit("setZetReportError", { message: "", boolean: false });
		} catch (e) {
			await commit("setZetReportError", {
				message: e.message,
				boolean: true
			});
			throw e;
		}
	},

	async startSessionToDep({ commit }, payload) {
		try {
			let response = await ZetReportService.openSession(payload, localStorage.getItem('cash_id'));
			await commit("setCurrentSession", response.data);
			await commit("openZetAtchotError", { message: "", boolean: false });
		} catch (e) {
			commit("openZetAtchotError", { message: e.message, boolean: true });
			return false;
		}
	},
	async getZReportMonthly({ commit }, payload) {
		try {
			ZetReportService.getMonthlyXReport(payload, localStorage.getItem('cash_id')).then(response => {
				commit("setMonthlyZReport", response.data);
			});
		} catch (e) {
			//let response = JSON.parse(e.request.response);
			//commit('fetchGoodError', {message: response.message, boolean: true});
			throw e;
		}
	},
	async getXReport({ commit }, data) {
		try {
			ZetReportService.getXReport(data, localStorage.getItem('cash_id')).then(response => {
				commit("setXReport", response.data);
			});
		} catch (e) {
			//let response = JSON.parse(e.request.response);
			//commit('fetchGoodError', {message: response.message, boolean: true});
			throw e;
		}
	}
};
const mutations = {
	setCurrentZReport(state, response) {
		state.currentZReport = response;
		state.currentReport = response;
	},
	setCurrentXReport(state, response) {
		state.currentXReport = response;
		state.currentReport = response;
	},
	/**
	 * 24.01.2020 DA QO'SHILDI ZREPORTNI ID ORQALI OLISH APISI O'ZGARGANDA
	 * @param {*} state
	 * @param {*} obj
	 */
	setZReportError(state, obj) {
		state.zReportError = obj;
	},

	/**
	 * 24.01.2020 DA QO'SHILDI ZREPORTNI ID ORQALI OLISH APISI O'ZGARGANDA
	 * @param {*} state
	 * @param {*} response
	 */
	setZReportById(state, response) {
		state.zReportById = response;
		state.currentReport = response;
	},

	setZetReportError(state, obj) {
		state.closeZreportError.message = obj.message;
		state.closeZreportError.boolean = true;
	},
	openZetAtchotError(state, obj) {
		state.zetReportError.message = obj.message;
		state.zetReportError.boolean = obj.boolean;
	},
	setCurrentSession(state, data) {
		state.currentSession = data;
	},
	setZetReport(state, data) {
		state.zetReport = data;
	},
	setXReport(state, data) {
		state.xReport = data;
	},
	setMonthlyZReport(state, data) {
		state.zetReportMonthly = data;
	}
};

export const zetReport = {
	namespaced: true,
	state,
	actions,
	mutations,
	getters
};
